// src/components/PrivateRoute.js
import { Navigate } from 'react-router-dom';
import { useLogin } from '../context/LoginContext';

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useLogin();

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
